export const contentPadding = '24px';
export const tableListWidth = '206px';
